import React, { Component } from "react";
import { UserConsumer } from "../../UserContext";
import Header from "../timesheetModule/Header";
import "./dashboard.scss";
import moment from "moment";
import Highcharts from "highcharts";
import PieChart from "highcharts-react-official";
import drilldown from "highcharts/modules/drilldown.js";
import HighchartsReact from "highcharts-react-official";
import {
	title,
	optionsPie,
	optionsProjPie,
	departmentIds,
	timehseetPerformance,
	TableDateFormat,
	APIDateFormat,
} from "./DashboardVariables";
import axios from "axios";
import { Dashboard_APIs } from "./DashboardAPIs";
import { connect } from "react-redux";
import {
	UpdateNavBarItem,
	UpdateNavBarTab,
} from "../../components/navbarRedux/action";
import CustomReactSelect from "../../components/CustomReactSelect";
import { Col, Row, Spinner } from "reactstrap";
let data = [],
	temp = [];
drilldown(Highcharts);

let token = null,
	isConsultant,
	empJoinedOn = false;

class MyDashboard extends Component {
	constructor(props) {
		super(props);
		this.chart = React.createRef();
		this.state = {
			allowChartUpdate: true,
			createdTicketsCount: 0,
			assignedTicketsCount: 0,
			sickLeaves: 0,
			annualLeaves: 0,
			compensationLeaves: 0,
			lateComingsCount: 0,
			lateSittingCount: 0,
			lastWeekMinutes: "0",
			currentWeekMinutes: "0",
			currentMonthMinutes: 0,
			currentMonthTime: "00:00",
			currentMonthExpectedHours: "0",
			totalProjectHours: 0,
			hoursSpendOnProjects: [],
			status: "None",
			statusId: 0,
			MeetingAndExceedingExp: [],
			MeetingExpectationPlus: [],
			MeetingExpectation: [],
			MeetingExpectationMinus: [],
			FailedToMeetExpectation: [],
			timesheetPerformanceChartLoading: true,
			timesheetPerformanceChart: {
				...timehseetPerformance,
			},
			timesheetPerformanceData: [],
			projPie: {
				...optionsProjPie,
			},
			tsPie: {
				...optionsPie,
			},
			yearList: [],
			workStation: {
				workFromOffice: "00",
				workFromHome: "00",
				continuingWorkFromOffice: "00",
			},
			workStationPercentage: { workFromOffice: "00", workFromHome: "00" },
		};
	}
	hoursToDecimal = (time) => {
		let a = time.split(":"); // split it at the colons
		for (let i = 0; i < a.length; i++) a[i] = parseInt(a[i]);
		let dec = a[0] + a[1] / 60;

		return dec;
	};
	componentDidMount() {
		if (window.location.href.indexOf("MyDashboard") === -1) {
			this.props?.userDetails?.designation.toString() === "4"
				? this.props.history.push("/CMDashboard")
				: this.props?.userDetails.empRole.includes("2") ||
				  this.props?.userDetails.empRole.includes("3")
				? this.props.history.push("/SpDashboard")
				: this.props.history.push("/");
		}
		const years = [];
		let currentYear = new Date().getFullYear();
		do {
			years.unshift({
				value: empJoinedOn,
				label: empJoinedOn.toString(),
			});
			empJoinedOn++;
		} while (empJoinedOn != currentYear + 1);
		this.setState({
			yearList: years,
			selectedYear: { value: currentYear, label: currentYear.toString() },
		});
		let headers = {
			Authorization: `Bearer ${token}`,
		};
		if (!isConsultant) {
			this.getMyCreatedAndAssignedTickets(headers);
			this.getMyLeaveQuota(headers);
			this.getMyLateComingSitting(headers);
			this.getMyWeeklyMonthlyHours(headers);
			this.getWorkStation(headers);
		}
		this.getMySaveProjectHours(headers);
		this.getMyTimeSheetsStatus(headers);
		axios
			.get(Dashboard_APIs.GetWorkingStatus_API, {
				headers: { Authorization: `Bearer ${token}` },
			})
			.then((data) => {
				this.setState({
					...this.state,
					status: data?.data?.description || "None",
					statusId: data?.data?.workingStatus || 0,
				});
			});

		this.getTimesheetPerformanceAPI(currentYear);
	}
	getTimesheetPerformanceAPI(year, onYearChange) {
		let chartObj = this?.chart?.current?.chart;
		if (chartObj) {
			chartObj.showLoading();
			if (onYearChange) chartObj.drillUp();
		}

		axios
			.get(
				`${Dashboard_APIs.GetTimesheetPerformanceChart}?Month=0&Year=${year}
			`,
				{
					headers: { Authorization: `Bearer ${token}` },
				}
			)
			.then((res) => {
				let Score = null;
				let DataTemp,
					DrillDataTemp,
					tempObjModified = null;
				let combinedData = [];
				let combinedDrillDownData = [];

				let tempVar = [];
				let monthly = res.data.monthly;
				//new
				let grade = null;
				let FMEData = [];
				let MEData = [];
				let MEPlusData = [];
				let MEMinusData = [];
				let MEEData = [];

				//WOrking
				monthly.forEach((item, index) => {
					let Scoredata = res.data.monthly[index].timesheetScoreCount;
					for (let i = 0; i < Scoredata.length; i++) {
						let score = Scoredata[i].score;
						if (Scoredata[i].numericScore != 0) {
							grade = {
								name: res.data.monthly[index].title?.split(
									","
								)[0],
								y:
									Scoredata[i].numericScore != -1
										? Scoredata[i].count
										: 0,
								drilldown:
									res.data.monthly[index].title?.split(
										","
									)[0],
							};

							switch (score) {
								case "MEE":
									MEEData.push(grade);
									break;
								case "ME+":
									MEPlusData.push(grade);
									break;
								case "ME":
									MEData.push(grade);
									break;
								case "ME-":
									MEMinusData.push(grade);
									break;
								case "FME":
									FMEData.push(grade);
									break;
								default:
									break;
							}
						}
					}
				});
				tempVar = [
					{
						name: "MEE",
						data: MEEData,
					},
					{
						name: "ME+",
						data: MEPlusData,
					},
					{
						name: "ME",
						data: MEData,
					},
					{
						name: "ME-",
						data: MEMinusData,
					},
					{
						name: "FME",
						data: FMEData,
					},
				];

				res.data.monthly.forEach((item, index) => {
					switch (res.data.monthly[index].score) {
						case 1:
							Score = "FME";
							break;
						case 2:
							Score = "ME";
							break;
						case 3:
							Score = "ME+";
							break;
						case 4:
							Score = "ME+";
							break;
						case 5:
							Score = "ME+";
							break;
						case -1:
							Score = "None";
							break;
						default:
							break;
					}

					if (Score != "None") {
						let weeklyScore =
							res.data.monthlyCollection[index].weeklyScore;

						let timesheetScoreCount =
							res.data.monthly[index].timesheetScoreCount;

						for (let i = 0; i < timesheetScoreCount.length; i++) {
							if (
								timesheetScoreCount[i].count != 0 &&
								timesheetScoreCount[i].numericScore != -1 &&
								timesheetScoreCount[i].numericScore != 0
							) {
								let item = {
									name: res.data.monthly[index].title?.split(
										","
									)[0],
									y: timesheetScoreCount[i].count,
									drilldown:
										res.data.monthly[index].title?.split(
											","
										)[0],
									att: timesheetScoreCount[i].score,
								};
								DataTemp = {
									name: timesheetScoreCount[i].score,
									drilldown:
										res.data.monthly[index].title?.split(
											","
										)[0],
									data: [item],
								};
								combinedData.push(DataTemp);
							}
						}
						let weeklyArray = [];
						let history = this.props.history;
						for (let i = 0; i < weeklyScore.length; i++) {
							let tempObj =
								weeklyScore[i] && Object.values(weeklyScore[i]);
							if (tempObj)
								tempObjModified = {
									name: moment(tempObj[0]).format(
										TableDateFormat
									),
									y: tempObj[1],
									events: {
										click: function (event) {
											history.push({
												pathname: "/WeeklyView",
												search:
													"?week=" +
													moment(tempObj[0]).format(
														APIDateFormat
													),
												state: {
													weekStartDate: moment(
														tempObj[0]
													).format(APIDateFormat),
												},
											});
										},
									},
								};

							weeklyArray.push(tempObjModified);
						}

						DrillDataTemp = {
							name: res.data.monthly[index].title?.split(",")[0],
							id: res.data.monthly[index].title?.split(",")[0],
							data: weeklyArray,
						};

						combinedDrillDownData.push(DrillDataTemp);
					}
				});

				this.setState({
					...this.state,
					timesheetPerformanceData: combinedData,
					timesheetPerformanceChartLoading: false,
				});
				if (chartObj) chartObj.hideLoading();

				this.setState((prevState) => {
					let timesheetPerformanceChart = Object.assign(
						{},
						prevState.timesheetPerformanceChart
					);
					timesheetPerformanceChart.series = tempVar;
					timesheetPerformanceChart.drilldown.series =
						combinedDrillDownData;
					return { timesheetPerformanceChart };
				});
			});
	}

	getMyTimeSheetsStatus = (headers) => {
		axios
			.get(`${Dashboard_APIs.GetMyTimeSheetsStatus_API}`, {
				headers: headers,
			})
			.then((res) => {
				data = [
					{
						name: "Pending",
						y: res.data.pending !== 0 && res.data.pending,
					},
					{
						name: "In Progress",
						y: res.data.inProgress !== 0 && res.data.inProgress,
					},
					{
						name: "Saved",
						y: res.data.saved !== 0 && res.data.saved,
					},
					{
						name: "Submitted",
						y: res.data.submitted !== 0 && res.data.submitted,
					},
					{
						name: "Approved",
						y: res.data.approved !== 0 && res.data.approved,
					},
					{
						name: "Rejected",
						y: res.data.rejected !== 0 && res.data.rejected,
					},
				];

				this.setState((prevState) => {
					let tsPie = Object.assign({}, prevState.tsPie);
					tsPie.series[0].data = data;
					tsPie.title.text = `Weeks<br><p style="font-size:21px">05</p>`;
					tsPie.series[0].dataLabels.format = "{point.y}";
					return { tsPie };
				});
			});
	};
	getMySaveProjectHours = (headers) => {
		axios
			.get(`${Dashboard_APIs.GetMySaveProjectHours_API}`, {
				headers: headers,
			})
			.then((res) => {
				//filtering projects with 0:0 time
				temp = res.data.hoursSpendOnProjects.filter(
					(proj) => proj.projectHours !== "0:0"
				);
				data = temp.map((proj, key) => ({
					name: proj.projectName,
					y: this.hoursToDecimal(proj.projectHours),
				}));

				this.setState((prevState) => {
					let projPie = Object.assign({}, prevState.projPie);
					projPie.series[0].data = data;
					projPie.subtitle.text =
						res.data.totalProjectHours < 10
							? "0" + res.data.totalProjectHours
							: res.data.totalProjectHours;
					projPie.series[0].dataLabels.format = "{point.y:.0f}";

					return { projPie };
				});
			});
	};
	getMyCreatedAndAssignedTickets = (headers) => {
		axios
			.get(`${Dashboard_APIs.GetMyCreatedAndAssignedTickets_API}`, {
				headers: headers,
			})
			.then((res) => {
				this.setState({
					createdTicketsCount: res.data.createdTicketsCount,
					assignedTicketsCount: res.data.assignedTicketsCount,
				});
			});
	};
	getMyLeaveQuota = (headers) => {
		axios
			.get(`${Dashboard_APIs.GetMyLeaveQouta_API}`, {
				headers: headers,
			})
			.then((res) => {
				this.setState({
					sickLeaves: res.data.sickLeaves,
					annualLeaves: res.data.annualLeaves,
					compensationLeaves: res.data.compensationLeaves,
				});
			});
	};
	getMyLateComingSitting = (headers) => {
		axios
			.get(`${Dashboard_APIs.GetMyLateComingSitting_API}`, {
				headers: headers,
			})
			.then((res) => {
				this.setState({
					lateComingsCount: res.data.lateComingsCount,
					lateSittingCount: res.data.lateSittingCount,
				});
			});
	};
	getWorkStation = (headers) => {
		//work Station count
		axios
			.get(`${Dashboard_APIs.GetWorkStation_API}`, {
				headers: headers,
			})
			.then((res) => {
				this.setState({
					workStation: res.data,
				});
			});
		//work Station percentage
		axios
			.get(`${Dashboard_APIs.GetWorkStationPercentage_API}`, {
				headers: headers,
			})
			.then((res) => {
				this.setState({
					workStationPercentage: res.data,
				});
			});
	};
	getMyWeeklyMonthlyHours = (headers) => {
		axios
			.get(`${Dashboard_APIs.GetMyWeeklyMonthlyHours_API}`, {
				headers: headers,
			})
			.then((res) => {
				this.setState({
					lastWeekMinutes: this.formatHours(res.data.lastWeekMinutes),
					currentWeekMinutes: this.formatHours(
						res.data.currentWeekMinutes
					),
					currentMonthTime: this.formatHours(
						res.data.currentMonthMinutes
					),
					currentMonthMinutes: res.data.currentMonthMinutes,
					currentMonthExpectedHours: res.data.expectedHours,
				});
			});
	};
	formatHours = (mins) => {
		let hours;
		hours = parseInt(mins / 60);
		mins = parseInt(mins % 60);
		if (hours < 10) hours = "0" + hours.toString();
		if (mins < 10) mins = "0" + mins.toString();
		return `${hours}:${mins}`;
	};

	redirectToScreen = (navItem, Tab, route) => {
		sessionStorage.setItem("NavbarTab", Tab);
		sessionStorage.setItem("NavbarItem", navItem);
		this.props.UpdateNavBarTab(Tab);
		this.props.UpdateNavBarItem(navItem);
		this.props.history.push(route);
	};
	render() {
		const statusColor = { 1: "#28a745", 2: "#ffc107", 3: "#dc3545" };
		let statusDropDown = [
			{ id: 1, description: "Working" },
			{ id: 2, description: "Waiting For Work" },
			{ id: 3, description: "Need Help" },
		];
		const setStatus = (statusNo, status) => {
			axios
				.post(
					Dashboard_APIs.SetWorkingStatus_API,
					{
						workingStatus: statusNo,
						description: status,
					},
					{
						headers: { Authorization: `Bearer ${token}` },
					}
				)
				.then((data) => {
					this.setState({ ...this.state, status: status });
					this.setState({ ...this.state, statusId: statusNo });
				});
		};
		return (
			<UserConsumer>
				{(userDetails) => {
					token = userDetails.token;
					isConsultant = false; // as, for now consultant dashboard is not customized
					empJoinedOn = userDetails.empJoinedOn.split("-")[0];
					return (
						<div className="container-fluid pl-4 pr-4">
							<Header title={title(userDetails)} />
							{!isConsultant ? (
								<div className="container-fluid">
									<div className="row mt-5 contentClass">
										<div className="col-lg-2 col-md-6 col-sm-12">
											<div
												className="col-md-12 mt-2 mt-lg-0 styleDiv0"
												style={{
													backgroundColor:
														statusColor[
															this.state.statusId
														],
												}}
											>
												<div className="displayPosition">
													<div>Work Status</div>
													<div className="dropdown">
														<button
															className="btn dropdownbtn dropdown-toggle"
															type="button"
															id="dropdownMenuButton1"
															data-bs-toggle="dropdown"
															aria-expanded="false"
														></button>
														<ul
															className="dropdown-menu"
															aria-labelledby="dropdownMenuButton1"
														>
															{statusDropDown.map(
																(data) => (
																	<li
																		key={
																			data.id
																		}
																	>
																		<a
																			className="dropdown-item"
																			href="#"
																			onClick={() => {
																				setStatus(
																					data.id,
																					data.description
																				);
																			}}
																		>
																			{
																				data.description
																			}
																		</a>
																	</li>
																)
															)}
														</ul>
													</div>
												</div>
												<div
													className="pt-4 text-center"
													style={{
														font: "Bold 29px/24px Poppins",
														lineHeight: "30px",
														cursor: "default",
													}}
												>
													{this.state.status}
												</div>
											</div>
										</div>

										<div className="col-lg-2 col-md-6 col-sm-12">
											<div className="col-md-12 mt-2 mt-lg-0 styleDiv2">
												<div className="statusLeave">
													Office Hours
												</div>
												<div
													className={
														this.state
															.currentMonthMinutes <
														this.state
															.currentMonthExpectedHours
															? "leaveCount pt-0 pt-md-0 pt-lg-4"
															: "leaveCount pt-0 pt-md-0 pt-lg-4"
													}
												>
													{
														this.state
															.currentMonthTime
													}
												</div>
												<div className="font-weight-bold pt-0 pt-md-0 pt-lg-1 text-center">
													Current Month
												</div>
											</div>
										</div>

										<div className="col-lg-4 col-md-12 col-sm-12">
											<div className="col-md-12 mt-2 mt-lg-0 styleDiv1">
												<div className="statusLeave">
													Office Hours
												</div>
												<div className="pt-5 sDiv1 officehoursBlock">
													<div className="pl-2">
														{this.state
															.lastWeekMinutes ===
														0
															? "00.00"
															: this.state
																	.lastWeekMinutes}
													</div>
													<div className="pr-3">
														{this.state
															.currentWeekMinutes ===
														0
															? "00.00"
															: this.state
																	.currentWeekMinutes}
													</div>
												</div>
												<div className="pt-4 sDiv2">
													<div className="pl-2">
														Last Week
													</div>
													<div className="pr-2">
														Current Week
													</div>
												</div>
											</div>
										</div>

										<div className="col-lg-2 col-md-6 col-sm-12">
											<div
												className="col-md-12 mt-2 mt-lg-0 lateComingDiv"
												onClick={() => {
													this.redirectToScreen(
														"OfficeHours",
														"GeneralTasks",
														`/MyOfficeHours?Status=${3}`
													);
												}}
											>
												<div className="statusLeave">
													Late Comings
												</div>
												<div className="leaveCount pt-4 text-center">
													{this.state
														.lateComingsCount < 10
														? "0" +
														  this.state
																.lateComingsCount
														: this.state
																.lateComingsCount}
												</div>
											</div>
										</div>
										<div className="col-lg-2 col-md-6 col-sm-12">
											<div
												className="col-md-12 mt-2 mt-lg-0 styleDivLateSitting"
												onClick={() => {
													this.redirectToScreen(
														"OfficeHours",
														"GeneralTasks",
														`/MyOfficeHours?Status=${9}`
													);
												}}
											>
												<div className="statusLeave ">
													Late Sittings
												</div>
												<div className="leaveCount text-center pt-4">
													{this.state
														.lateSittingCount < 10
														? "0" +
														  this.state
																.lateSittingCount
														: this.state
																.lateSittingCount}
												</div>
											</div>
										</div>
									</div>
									<div className="contentClass mt-3 mt-lg-5 mt-md-5 row">
										<div className="col-lg-6 col-md-12">
											<div className="col-md-12 leaveRow1 mt-5 mt-lg-0 mt-md-0 mb-3">
												<div className="workStation title">
													Work Station
													<span className="small">
														{
															"\xa0\xa0(Current\xa0Month)"
														}
													</span>
												</div>
												<div className="workStation justify-content-around row py-3">
													<div
														className="p-3 workStationLink"
														onClick={() => {
															this.redirectToScreen(
																"OfficeHours",
																"GeneralTasks",
																`/MyOfficeHours/${2}`
															);
														}}
													>
														<div
															className="section1 d-flex align-items-center"
															style={{
																justifyContent:
																	"center",
																color: "#57585a",
															}}
														>
															{this.state
																.workStation
																? this.state
																		.workStation
																		.workFromOffice
																: "00"}
															<div
																className="ml-2"
																style={{
																	font: "normal 14px Poppins",
																}}
															>
																{" "}
																{this.state
																	.workStationPercentage
																	.workFromOfficePercentage
																	? "( " +
																	  this.state.workStationPercentage.workFromOfficePercentage.toFixed(
																			1
																	  ) +
																	  "% )"
																	: null}
															</div>
														</div>
														<div className="sectionClass">
															Work From
															<br />
															Office
														</div>
													</div>
													<div className="workStation borderClass1 d-md-block d-none p-1 p-md-2 p-lg-1"></div>
													<div
														className="p-3 workStationLink"
														onClick={() => {
															this.redirectToScreen(
																"OfficeHours",
																"GeneralTasks",
																`/MyOfficeHours/${1}`
															);
														}}
													>
														<div
															className="section1 d-flex align-items-center"
															style={{
																justifyContent:
																	"center",
															}}
														>
															{this.state
																.workStation
																? this.state
																		.workStation
																		.workFromHome
																: "00"}
															<div
																className="ml-2"
																style={{
																	font: "normal 14px Poppins",
																}}
															>
																{" "}
																{this.state
																	.workStationPercentage
																	.workFromHomePercentage
																	? "( " +
																	  this.state.workStationPercentage.workFromHomePercentage.toFixed(
																			1
																	  ) +
																	  "% )"
																	: null}
															</div>
														</div>
														<div className="sectionClass">
															Work From
															<br />
															Home
														</div>
													</div>
													<div className="workStation borderClass1 d-md-block d-none p-1 p-md-2 p-lg-1"></div>
													<div
														className="p-3 workStationLink"
														onClick={() => {
															this.redirectToScreen(
																"OfficeHours",
																"GeneralTasks",
																`/MyOfficeHours/${3}`
															);
														}}
													>
														<div
															className="section1 d-flex align-items-center"
															style={{
																justifyContent:
																	"center",
															}}
														>
															{this.state
																.workStation
																? this.state
																		.workStation
																		.continuingWorkFromOffice ===
																  0
																	? "0"
																	: this.state
																			.workStation
																			.continuingWorkFromOffice
																: "0"}
															<div
																className="ml-2"
																style={{
																	font: "normal 14px Poppins",
																}}
															>
																{" "}
																{this.state
																	.workStationPercentage
																	.contiuningWorkFromOfficePercentage
																	? "( " +
																	  this.state.workStationPercentage.contiuningWorkFromOfficePercentage.toFixed(
																			1
																	  ) +
																	  "% )"
																	: null}
															</div>
														</div>
														<div className="sectionClass">
															Continuing
															<br />
															Work From Office
														</div>
													</div>
												</div>
											</div>

											<div className="col-md-12 timesheetDiv mt-3">
												<div className="pt-3 title">
													Timesheet Status
													<span className="small">
														{
															"\xa0\xa0(05\xa0Weeks)"
														}
													</span>
												</div>
												<div id="timesheetchart">
													<PieChart
														highcharts={Highcharts}
														options={
															this.state.tsPie
														}
													/>
												</div>
											</div>

											<div className="col-md-12 m-0 mt-3 px-0 row">
												<div
													className={`${
														departmentIds.includes(
															userDetails.department.toString()
														)
															? "col-md-6 "
															: "col-md-12 "
													} col-sm-12 pl-0 pr-0`}
													style={{
														cursor: "pointer",
													}}
												>
													<div
														className="col-md-12 mt-1 mt-lg-0 mt-md-0 ticketDiv"
														onClick={() => {
															this.redirectToScreen(
																"MyTickets",
																"GeneralTasks",
																"/MyTickets"
															);
														}}
													>
														<div className="statusLeave">
															Pending Support
															Tickets
														</div>
														<div className="leaveCount p-3">
															{this.state
																.createdTicketsCount <
															10
																? "0" +
																  this.state
																		.createdTicketsCount
																: this.state
																		.createdTicketsCount}
														</div>
													</div>
												</div>
												{departmentIds.includes(
													userDetails.department.toString()
												) && (
													<div
														className="col-md-6 col-sm-12 pr-0 pl-0 pl-md-2"
														style={{
															cursor: "pointer",
														}}
													>
														<div
															className="col-md-12 mt-2 mt-lg-0 mt-md-0 ticketDiv2"
															onClick={() => {
																departmentIds.includes(
																	userDetails.department.toString()
																) &&
																	this.redirectToScreen(
																		"ResourceTickets",
																		"GeneralTasks",
																		"/DepartmentTicketListing"
																	);
															}}
														>
															<div className="statusLeave">
																Pending Assigned
																Tickets
															</div>
															<div className="leaveCount p-1">
																{this.state
																	.assignedTicketsCount <
																10
																	? "0" +
																	  this.state
																			.assignedTicketsCount
																	: this.state
																			.assignedTicketsCount}
															</div>
														</div>
													</div>
												)}
											</div>
										</div>
										<div className="col-lg-6 col-md-12">
											<div
												className="col-md-12 leaveRow1 mt-5 mt-lg-0 mt-md-0"
												onClick={() => {
													this.redirectToScreen(
														"LeavesView",
														"GeneralTasks",
														"/ManageLeavesView"
													);
												}}
											>
												<div className="statusLeave1 title">
													Leaves Quota
												</div>
												<div className="justify-content-around row py-3">
													<div className="p-4 ">
														<div className="section1">
															{this.state
																.sickLeaves <
																10 &&
															this.state
																.sickLeaves >= 0
																? "0" +
																  this.state
																		.sickLeaves
																: this.state
																		.sickLeaves}
														</div>
														<div className="sectionClass">
															Sick
														</div>
													</div>
													<div className="borderClass1 d-md-block d-none"></div>
													<div className="p-4">
														<div className="section1">
															{this.state
																.compensationLeaves <
																10 &&
															this.state
																.compensationLeaves >=
																0
																? "0" +
																  this.state
																		.compensationLeaves
																: this.state
																		.compensationLeaves}
														</div>
														<div className="sectionClass">
															compensation
														</div>
													</div>
													<div className="borderClass2 d-md-block d-none"></div>
													<div className="p-4 ">
														<div className="section1">
															{this.state
																.annualLeaves <
																10 &&
															this.state
																.annualLeaves >=
																0
																? "0" +
																  this.state
																		.annualLeaves
																: this.state
																		.annualLeaves}
														</div>
														<div className="sectionClass">
															Annual
														</div>
													</div>
												</div>
											</div>
											<div className="col-md-12 currentProjHours mt-3 ">
												<div className="p-3 title">
													Current Month Project Hours
												</div>
												<div id="currentProjHoursChart">
													<PieChart
														highcharts={Highcharts}
														options={
															this.state.projPie
														}
													/>
												</div>
											</div>
										</div>
									</div>

									<div className="row mt-5 contentClass">
										<div
											className="col-sm-12 col-md-12 col-sm-12 mt-2 mt-md-0 mb-3 d-flex"
											style={{
												justifyContent: "space-between",
											}}
										>
											<Row
												className="d-flex col-12"
												style={{
													justifyContent:
														"space-between",
												}}
											>
												<Col className="col-4 pl-0">
													<div className="title ml-2">
														Timesheets Performance
														Report
													</div>
												</Col>
												<Row>
													<Col
														className="pr-0"
														style={{
															zIndex: 100,
														}}
													>
														<CustomReactSelect
															className="CMYearDropdown"
															options={
																this.state
																	.yearList
															}
															onChange={(
																event
															) => {
																let value =
																	event.value;
																this.setState({
																	selectedYear:
																		{
																			value: value,
																			label: value.toString(),
																		},
																});
																this.getTimesheetPerformanceAPI(
																	value,
																	true
																);
															}}
															value={
																this.state
																	.selectedYear
															}
															paginationDropDown={
																true
															}
														/>
													</Col>
												</Row>
											</Row>
										</div>
										<div
											className="col-sm-12 col-md-12 col-sm-12 timesheetPerformance"
											id="timesheetPerformanceBar"
										>
											{this.state
												.timesheetPerformanceChartLoading ? (
												<div className="graphLoadingSpinner">
													<Spinner />
												</div>
											) : (
												<HighchartsReact
													allowChartUpdate={
														this.allowChartUpdate
													}
													highcharts={Highcharts}
													options={
														this.state
															.timesheetPerformanceChart
													}
													ref={this.chart}
												/>
											)}
										</div>
									</div>
								</div>
							) : (
								<div className="d-flex">
									<div className="col-lg-6 col-md-6 graphDiv1 h-50 mt-2 mt-lg-0 mt-md-0 mr-2">
										<div className="p-3 title">
											Current Month Project Hours
										</div>
										<div id="currentProjHoursChart">
											<PieChart
												highcharts={Highcharts}
												options={this.state.projPie}
											/>
										</div>
									</div>
									<div className="col-lg-6 col-md-6  graphDiv2 h-50 mt-2 mt-lg-0 mt-md-0">
										<div className="p-3 title">
											Timesheet Status
											<span className="small">
												{"\xa0\xa0(05\xa0Weeks)"}
											</span>
										</div>
										<div id="timesheetchart">
											<PieChart
												highcharts={Highcharts}
												options={this.state.tsPie}
											/>
										</div>
									</div>
								</div>
							)}
						</div>
					);
				}}
			</UserConsumer>
		);
	}
}
const mapDispatchToProps = {
	UpdateNavBarItem,
	UpdateNavBarTab,
};
export default connect(null, mapDispatchToProps)(MyDashboard);
